<template>
  <div v-loading="isLoading">
    <el-table
      :data="profiles"
      stripe
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-row :gutter="10">
            <el-col :md="12">
              <el-card shadow="never">
                <template slot="header">
                  <span>Profile</span>
                </template>
                <el-row>
                  <el-col :md="12">
                    <p><strong>Display Name: </strong>{{ props.row.profile? props.row.profile.name_display || 'None' : 'None' }}</p>
                    <p><strong>Full Name: </strong>{{ props.row.profile ? props.row.profile.name_full || 'None' : 'None' }}</p>
                    <p><strong>Position: </strong>{{ props.row.profile ? props.row.profile.position || 'None' : 'None' }}</p>
                  </el-col>
                  <el-col :md="12">
                    <p><strong>Email: </strong>{{ props.row.profile ? props.row.profile.email || 'None' : 'None' }}</p>
                    <p><strong>Primary Phone: </strong>{{ props.row.profile ? props.row.profile.phone_primary || 'None' : 'None' }}</p>
                    <p><strong>Secondary Phone: </strong>{{ props.row.profile ? props.row.profile.phone_secondary || 'None' : 'None' }}</p>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
            <el-col :md="12">
              <el-card shadow="never">
                <template slot="header">
                  <span>Role</span>
                </template>
                <el-row>
                  <el-col :md="12">
                    <p><strong>Name: </strong>{{ props.row.role ? props.row.role.name || 'None' : 'None' }}</p>
                    <p><strong>Description: </strong>{{ props.row.role ? props.row.role.description || 'None' : 'None' }}</p>
                  </el-col>
                  <el-col :md="12">
                    <p><strong>Level Access: </strong>{{ props.row.role.level ? props.row.role.level.access || 'None' : 'None' }}</p>
                    <p><strong>Level Description: </strong>{{ props.row.role.level ? props.row.role.level.description || 'None' : 'None' }}</p>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
          </el-row>
        </template>
      </el-table-column>

      <!-- <el-table-column
        label="Team"
        prop="team"
        :formatter="(row, col, cellValue) => cellValue ? cellValue.name : '-'"
      /> -->

      <el-table-column
        label="User"
        prop="profile"
        width="320px"
        sortable
        :sort-method="sortProfiles"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue ? cellValue.name_full : '-'"
      />

      <el-table-column
        label="Role"
        prop="role"
        width="320px"
        sortable
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue ? cellValue.name : '-'"
      />

      <el-table-column
        label="Actions"
        align="right"
        min-width="270px"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click.native="editProfile(scope.$index, scope.row)"
          >
            Edit
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click.native="deleteProfile(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>
    <!-- Edit Form -->
    <TeamProfileEditForm
      v-if="isShowEditForm"
      ref="editForm"
      :profile-role-team="profileRoleTeam"
      :account-id="accountId"
      :team-id="teamId"
      :is-show.sync="isShowEditForm"
      @saved="loadTable"
    />
    <el-dialog
      title="User's Profile"
      :visible.sync="isShowCreateUserForm"
      width="60%"
      :close-on-click-modal="false"
    >
      <UsersForm
        ref="userForm"
        :user="user"
      />
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="default"
          @click.native="isShowCreateUserForm = false"
        >
          Cancel
        </el-button>
        <el-button
          type="primary"
          :loading="isSaving"
          @click.native="preSave"
        >
          {{ (user && user.id) ? 'Save' : 'Create' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TeamProfileEditForm from '@/components/Application/Manage/Account/TeamProfileEditForm'
import UsersForm from '@/components/Application/Manage/Users/Form.vue'
export default {
  components: {
    UsersForm,
    TeamProfileEditForm
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    teamId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      profileRoleTeam: null,
      profiles: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: false,
      isShowEditForm: false,
      user: null,
      isShowCreateUserForm: false,
      isSaving: false
    }
  },
  created () {
    this.loadTable()
  },
  mounted () {
    this.actions = [
      [
        {
          name: 'Attach Profile',
          icon: ['fal', 'plus'],
          event: () => {
            this.profileRoleTeam = new this.$sdk.profileroleteam()
            this.isShowEditForm = true
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => this.loadTable()
        }
      ],
      [
        {
          name: 'Export',
          icon: ['fal', 'file-export'],
          event: () => this.exportCsv
        }
      ],
      [
        {
          name: 'Create User',
          icon: ['fal', 'file-import'],
          event: () => {
            this.user = new this.$sdk.profile()
            this.isShowCreateUserForm = true
          }
        }
      ]
    ]
  },
  methods: {
    exportCsv () {
      // const csv = this.$papa.unparse(formattedProfiles)
      // Convert the profiles data to CSV format
      const formattedProfiles = this.profiles.map(profile => {
        return {
          'Display Name': profile.profile ? profile.profile.name_display || 'None' : 'None',
          'Full Name': profile.profile ? profile.profile.name_full || 'None' : 'None',
          'Position': profile.profile ? profile.profile.position || 'None' : 'None',
          'Email': profile.profile ? profile.profile.email || 'None' : 'None',
          'Primary Phone': profile.profile ? profile.profile.phone_primary || 'None' : 'None',
          'Secondary Phone': profile.profile ? profile.profile.phone_secondary || 'None' : 'None',
          'Role Name': profile.role ? profile.role.name || 'None' : 'None',
          'Role Description': profile.role ? profile.role.description || 'None' : 'None'
        }
      })
      console.log('Formatted Profiles', formattedProfiles)
      const csv = this.$papa.unparse(formattedProfiles)
      console.log('CSV', csv)
      let blob = new Blob([csv], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `profiles.csv`
      link.click()
    },
    sortProfiles (a, b) {
      return a.profile.name_full.localeCompare(b.profile.name_full)
    },
    loadTable () {
      this.isLoading = true
      this.$sdk.profileroleteam.list(builder => {
        builder.context = { resource: 'pivot' }
        builder.include = ['account_team', 'profile', 'account_role']
        builder.filters = { pivot_profile_role_team_team: [this.teamId] }
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'created_at:desc'
      })
        .then(res => {
          this.profiles = res
          this.total = res.total
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    editProfile (index, row) {
      this.profileRoleTeam = row.clone()
      this.isShowEditForm = true
    },
    deleteProfile (index, row) {
      this.$confirm('Are you sure to delete this?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete(builder => {
          builder.context = { resource: 'pivot' }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    },
    preSave () {
      this.$refs['userForm'].validate(this.save)
    },
    save () {
      this.isSaving = true
      let name = this.user.name_full
      this.user.create().then(() => {
        this.$message.success(`Successfully created user ${name}`)
        this.isSaving = false
        this.isShowCreateUserForm = false
      })
        .catch(err => {
          this.isSaving = false
          this.$message.error(`An error occurred while creating user ${name}`)
          throw err
        })
        .finally(() => { this.isShowCreateUserForm = false })
    }
  }
}
</script>

<style>

</style>
